var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1907",
    d: "M3.6698 8.41933C3.6698 6.88419 4.9143 5.63969 6.44944 5.63969C7.98458 5.63969 9.22908 6.88419 9.22908 8.41933C9.22908 9.95447 7.98458 11.199 6.44944 11.199C4.9143 11.199 3.6698 9.95447 3.6698 8.41933Z",
    stroke: "currentColor",
    strokeWidth: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1911",
    d: "M8.00974 17H2.60036C1.68074 17 1.02782 16.1039 1.30942 15.2285C2.05744 12.9027 3.86116 11.2197 6.43558 11.2197C7.66368 11.2197 8.80228 11.6026 9.73854 12.2557",
    stroke: "currentColor",
    strokeWidth: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1915",
    d: "M10.6881 3.77968C10.6881 2.24454 11.9326 1.00004 13.4678 1.00004C15.0029 1.00004 16.2474 2.24454 16.2474 3.77968C16.2474 5.31483 15.0029 6.55933 13.4678 6.55933C11.9326 6.55933 10.6881 5.31483 10.6881 3.77968Z",
    stroke: "currentColor",
    strokeWidth: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1919",
    d: "M9.25244 8.38965C10.3062 7.27508 11.7986 6.57963 13.4535 6.57963C14.6816 6.57963 15.8202 6.96261 16.7565 7.61565",
    stroke: "currentColor",
    strokeWidth: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1927",
    d: "M16.7542 14.9736H16.7558",
    stroke: "currentColor",
    strokeWidth: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1927-copy",
    d: "M14.3462 14.9722V14.9851",
    stroke: "currentColor",
    strokeWidth: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1927-copy-2",
    d: "M11.9325 14.9736H11.9342",
    stroke: "currentColor",
    strokeWidth: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgGroup;